import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const Sidebar = styled(Box)({
  width: '480px',
  padding: '45px',
  background: '#111111',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  height: '100%',
});

export default Sidebar;
